import type { ReactNode } from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function AgentMsg({
  children,
  pending = false,
  className,
}: {
  children: ReactNode;
  /** Affiche un spinner discret en début de bulle. */
  pending?: boolean;
  className?: string;
}) {
  return (
    <div className={cn("flex justify-start", className)}>
      <div className="max-w-[85%] rounded-2xl rounded-bl-md bg-card border border-border text-foreground px-4 py-2.5 text-[13px] leading-relaxed shadow-card">
        {pending ? (
          <Loader2 className="size-3.5 animate-spin opacity-70" />
        ) : (
          children
        )}
      </div>
    </div>
  );
}
